module.exports = __webpack_public_path__ + "img/cotentsuite13.b7298b67.png";